import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['activeWebsite']),
  },
  watch: {
    activeWebsite: {
      handler() {
        this.requestData()
      },
      deep: true,
      immediate: true,
    },
  },
}
